import React from "react";
import styled from "@emotion/styled";
import PropTypes from "prop-types";
import { StHeadline } from "@mediamath/design-system-eng";

// Totally not trolling here...
export const UNIVERSALLY_AGREED_UPON_PADDING = "15px";

const StHeaderHolder = styled("div")`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  min-height: ${({ minHeight }) => minHeight || undefined};
  padding-top: ${({ paddingTop }) =>
    paddingTop || UNIVERSALLY_AGREED_UPON_PADDING};
  padding-left: ${({ paddingLeft }) =>
    paddingLeft || UNIVERSALLY_AGREED_UPON_PADDING};
  padding-right: ${({ paddingRight }) =>
    paddingRight || UNIVERSALLY_AGREED_UPON_PADDING};
  padding-bottom: ${({ paddingBottom }) =>
    paddingBottom || UNIVERSALLY_AGREED_UPON_PADDING};

  h1,
  h2,
  h3 {
    margin: 0 !important;
  }
`;

const renderItems = (itemsToRender) =>
  typeof itemsToRender === "function" ? itemsToRender() : itemsToRender;

const ModuleHeader = ({
  testId,
  headline,
  leftSideItems,
  rightSideItems,
  paddingBottom,
  paddingTop,
  paddingLeft,
  paddingRight,
  minHeight,
}) => (
  <StHeaderHolder
    paddingBottom={paddingBottom}
    paddingTop={paddingTop}
    paddingLeft={paddingLeft}
    paddingRight={paddingRight}
    minHeight={minHeight}
  >
    <React.Fragment>
      {headline && !leftSideItems ? (
        <StHeadline data-testid={testId}>{headline}</StHeadline>
      ) : (
        renderItems(leftSideItems)
      )}
      {renderItems(rightSideItems)}
    </React.Fragment>
  </StHeaderHolder>
);

ModuleHeader.propTypes = {
  headline: PropTypes.node,
  leftSideItems: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  rightSideItems: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  paddingBottom: PropTypes.string,
  paddingTop: PropTypes.string,
  paddingLeft: PropTypes.string,
  paddingRight: PropTypes.string,
  testId: PropTypes.string,
  minHeight: PropTypes.string,
};

ModuleHeader.defaultProps = {
  headline: <div />,
  leftSideItems: undefined,
  rightSideItems: undefined,
  paddingBottom: undefined,
  paddingTop: undefined,
  paddingLeft: undefined,
  paddingRight: undefined,
  testId: undefined,
  minHeight: undefined,
};

export default ModuleHeader;
